// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BMalG06gmfA9vX8PNxeb {
    flex-basis: 33%;
    color: rgb(2, 99, 224);
    border: none;
    height: 6rem;
    box-shadow: none;
    font-size: 2rem;
    background-color: rgb(255, 255, 255);
}


.BMalG06gmfA9vX8PNxeb:disabled,
.BMalG06gmfA9vX8PNxeb[disabled]{
  color:rgb(174, 178, 193)
}`, "",{"version":3,"sources":["webpack://./src/components/Dialer/DtmfButton.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oCAAoC;AACxC;;;AAGA;;EAEE;AACF","sourcesContent":[".button {\n    flex-basis: 33%;\n    color: rgb(2, 99, 224);\n    border: none;\n    height: 6rem;\n    box-shadow: none;\n    font-size: 2rem;\n    background-color: rgb(255, 255, 255);\n}\n\n\n.button:disabled,\n.button[disabled]{\n  color:rgb(174, 178, 193)\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `BMalG06gmfA9vX8PNxeb`
};
export default ___CSS_LOADER_EXPORT___;
